import { validateEmptyField } from '../../../../validators/validateEmptyField';
import { validateZipCode } from '../../../../validators/validateZipCode';
import { validateSpanishID } from '../../../../validators/validateSpanishID';
import { validateBirthDay } from '../../../../validators/validateBirthDay';
import { validateLicenceDate } from '../../../../validators/validateLicenceDate';
import moment from 'moment';

export const ValidateField = (formType, formValues, name, value) => {
  const isTomador = formType === 'tomador';

  let isValid = false;

  switch (name) {
    case 'NIF':
      isValid = validateNif(value);
      break;

    case 'Nacionality':
      isValid = !isTomador || validateNationality(value);
      break;

    case 'FechaNacimiento':
      isValid = validateBirthDate(value);
      break;

    case 'FechaCarne':
      isValid = validateDrivingLicenceDate(formValues.FechaNacimiento, value);
      break;

    case 'FechaEfecto':
      isValid = !isTomador || validateEffectiveDate(value);
      break;

    case 'CodigoPostal':
      isValid = validatePostalCode(value);
      break;
  }

  return isValid;
};

export const ValidateForm = (formValues, formType) => {
  const isTomador = formType === 'tomador';

  const errors = {
    NIF: !validateNif(formValues.NIF),

    Nacionality: isTomador && !validateNationality(formValues.Nacionality),

    FechaNacimiento: !validateBirthDate(formValues.FechaNacimiento),

    FechaCarne: !validateDrivingLicenceDate(formValues.FechaNacimiento, formValues.FechaCarne),

    FechaEfecto: isTomador && !validateEffectiveDate(formValues.FechaEfecto),

    CodigoPostal:
      !validatePostalCode(formValues.CodigoPostal) ||
      !validateProvinceAndPopulation(formValues.IdProvince, formValues.IdPoblacion),
  };

  return errors;
};

export const isInfoValid = (formValues, formType) => {
  const errors = ValidateForm(formValues, formType);

  return !Object.values(errors).some((hasError) => hasError);
};

const validateNif = (value) => {
  const nif = value?.trim() ?? '';
  const isValid = nif !== '' && validateSpanishID(nif);

  return isValid;
};
const validateNationality = (value) => {
  return validateEmptyField(value);
};
const validateBirthDate = (value) => {
  return validateEmptyField(value) && validateBirthDay(value);
};
const validateDrivingLicenceDate = (birthDate, licenceDate) => {
  return validateEmptyField(licenceDate) && validateLicenceDate(birthDate, licenceDate);
};
const validateEffectiveDate = (value) => {
  if (!validateEmptyField(value)) {
    return false;
  }

  const effectiveDate = moment(value, 'DD/MM/YYYY', true);

  if (!effectiveDate.isValid()) {
    return false;
  }

  return effectiveDate.isSameOrAfter(moment(), 'day');
};
const validatePostalCode = (postalCode) => {
  return validateEmptyField(postalCode) && validateZipCode(postalCode);
};
export const validateProvinceAndPopulation = (idProvince, idPopulation) => {
  return validateEmptyField(idProvince) && validateEmptyField(idPopulation);
};
